var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "pb-5" },
    [
      _c(
        "v-card-title",
        [
          _c("span", { staticClass: "text-h5" }, [
            _vm.is_backcountrysafary
              ? _c("span", [_vm._v("Delivery")])
              : _vm._e(),
            _vm._v(" Address"),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("modal-close")
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-container", [
        _c(
          "div",
          { staticClass: "mt-5" },
          [
            _c(
              "v-col",
              { attrs: { "offset-md": "1", cols: "12", md: "10" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Property Name" },
                  model: {
                    value: _vm.reservation.delivery_property_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.reservation, "delivery_property_name", $$v)
                    },
                    expression: "reservation.delivery_property_name",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: { label: "Property Address" },
                  model: {
                    value: _vm.reservation.delivery_address,
                    callback: function ($$v) {
                      _vm.$set(_vm.reservation, "delivery_address", $$v)
                    },
                    expression: "reservation.delivery_address",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-col",
              {
                staticStyle: { "text-align": "right" },
                attrs: { "offset-md": "1", cols: "12", md: "10" },
              },
              [
                _c("v-btn", { on: { click: _vm.Close } }, [_vm._v("Close")]),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "ml-2",
                    attrs: { color: "primary" },
                    on: { click: _vm.Save },
                  },
                  [_vm._v("Save")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }